import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
declare var setSmartechEnable;

@Injectable()
export class SmtAuthGaurd implements CanActivate {
	smartechEnabled = setSmartechEnable;

	constructor(
	) {
	}

	allowedPaths = [
		'/billings/postpaid-billing',
		'/billings/details',
		'/settings/template',
		'/grcs/template_wrapper',
		'/opt',
		'/live'
	]

	redirectToLogout(url) {
    localStorage.removeItem('whatsappToken');
		window.location.href = `${url}`;
	}
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): boolean {

		if (this.smartechEnabled) {
			console.log(this.smartechEnabled, 'IF same domain URL................');
			let path = state.url;
			// path.startsWith('/settings/template') || path.startsWith('/grcs/template_wrapper') || path.startsWith('/opt') || path.startsWith('/live')
			const smtAllowed = path.startsWith('/billings/postpaid-billing') || path.startsWith('/billings/details') || path.startsWith('/settings/template') || path.startsWith('/grcs/template_wrapper') || path.startsWith('/opt') || path.startsWith('/live');
			if (smtAllowed) {
				return true;
			} else {
				//this.redirectToLogout(environment.api_url);
				return false;
			}
		}
		return true;
	}
	checkIfPathStartsWithAllowedPaths(path): boolean {
		let flag = false;
		this.allowedPaths.forEach((allowedPath: string) => {
			if (path.startsWith(allowedPath)) {
				flag = true;
			}
		})
		return flag;
	}
}
